import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, Teleport as _Teleport, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fee5f026"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card_text_and_image_wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import TextBlock from "../../blocks/TextBlock.vue";
import ContentWrapper from "../../generics/ContentWrapper.vue";
import PageTitle from "../../blocks/PageTitle.vue";
import CustomPic from "../../generics/CustomPic.vue";
import meta from "@/data/meta.json";
import Breadcrumbs from "@/components/generics/BreadCrumbs.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'ParisGuide',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      (_openBlock(), _createBlock(_resolveDynamicComponent('script'), { type: "application/ld+json" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(meta).ParisGuide), 1)
        ]),
        _: 1
      }))
    ])),
    _createVNode(PageTitle, {
      text: "Paris",
      "text-color": "black",
      "border-color": "black",
      backgroundImageClass: "background-champs-elysees"
    }),
    _createVNode(ContentWrapper, { showBreadcrumbs: true }, {
      default: _withCtx(() => [
        _createVNode(Breadcrumbs),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(TextBlock, null, {
            default: _withCtx(() => [
              _createTextVNode(" När man är ute och reser vill man uppleva de bästa godbitarna Europa har att erbjuda. Därför ska man, utan tvekan, besöka Paris. Med en uppsjö utav mästerverk så som Eiffeltornet, Notre Dame, Triumfbågen och Louvren är staden en av de bästa. Inte långt ifrån staden finns både världshistoriska arv och underbar familjeunderhållning. Det är förstås Versailles, Normandie och Dineyland på fråga. Eiffeltornet känner nog alla till. Ett 300 meter högt järntorn konstruerat av Gustave Eiffel. Tornet är förmodligen Paris mest kända byggnad och bland de landmärken som finns i världen är det ett av de mest kända. "),
              _hoisted_2,
              _hoisted_3,
              _createTextVNode(" Notre Dame, känt från inte minst Disneys uppskattade film ”Ringaren i Notre Dame”, var länge ett måste att besöka. Katedralen låg på en ö i Seine och var byggd i gotisk stil. Dessvärre drabbades byggnaden av en omfattande brand år 2019 och sedan dess återställs byggnaden. När väl katedralen öppnar upp igen vill vi rekommendera en visit till söndagsmässan, vilken är något riktigt spektakulärt. "),
              _hoisted_4,
              _hoisted_5,
              _createTextVNode(" Även om du inte är speciellt konstintresserad kan nationalmuseet Louvren ändå fånga ditt intresse. I dess salar finns tusentals konstverk med Leonardo da Vincis ”Mona Lisa” i spetsen. Detta är även platsen där delar av filmen ”Da Vinci-koden” var inspelad. Alltså lockar den även filmälskaren, men förmodligen många andra. När det gäller att åka tunnelbana så låter det väl inte som något speciellt, men Paris har gjort det! Den hållplats som inte får missas är hållplatsen vid Louvren, en station utan dess like! "),
              _hoisted_6,
              _hoisted_7,
              _createVNode(CustomPic, { picturePath: "pictures/eiffeltornet-paris-frankrike.jpeg" }),
              _hoisted_8,
              _hoisted_9,
              _createTextVNode(" Triumfbågen är ett stor monument i form av en cirka 50 meter hög valvbåge i ena änden av Champs-Élysées. Den byggdes för att hedra Frankrikes armé och till minne av segern vid Austerlitz 1805, men nu finns där även ett monument känt som \"den okände soldatens grav\" vilken visar aktning för de alla stupade under första världskriget. "),
              _hoisted_10,
              _hoisted_11,
              _createTextVNode(" ”Restaurant Chartier” är inrett i ett gammalt apotek. Maten är billig, men framför allt god. Denna restaurang ligger i stadsdelen Monmartre och är ett synnerligen värt besök. "),
              _hoisted_12,
              _hoisted_13,
              _createTextVNode(" Samtidigt som Monmarte besöks, passa då på att besöka konstnärerna på torget i denna stadsdel. Konstnärerna står och målar på torget samtidigt som de säljer sin konst. Många konstnärer har fått sin inspiration här och kanske står framtidens Picasso och väntar på sitt genombrott. ")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})